import BenefitIcon from './BenefitIcon';

export default BenefitIcon;
